import React from 'react';
import { BrowserRouter as Router, Route, Switch, withRouter } from 'react-router-dom';
import classnames from 'classnames';
import useStyles from './styles';
import Header from '../Header/Header';
import List from '../../pages/instances/List';
import Create from '../../pages/instances/Create';

function LayoutWithoutSidebar(props) {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <>
                <Header history={props.history} sidebar={false} />
                <div
                    className={classnames(classes.content, {
                        [classes.contentShift]: true
                    })}
                >
                    <div className={classes.fakeToolbar} />
                    <Switch>
                        <Router>
                            <Route exact path="/instances/list" component={List} />
                            <Route exact path="/instances/create" component={Create} />
                            <Route exact path="/instances/create/:tenantid" component={Create} />
                        </Router>
                    </Switch>
                </div>
            </>
        </div>
    );
}

export default withRouter(LayoutWithoutSidebar);
